const fluModelOptions = [{ value: 'ENSEMBLE', label: 'Ensemble' }]

export default fluModelOptions
